import { render, staticRenderFns } from "./VCMathJP.vue?vue&type=template&id=99b5c4a2"
import script from "./VCMathJP.vue?vue&type=script&lang=js"
export * from "./VCMathJP.vue?vue&type=script&lang=js"
import style0 from "./VCMathJP.vue?vue&type=style&index=0&id=99b5c4a2&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports